import { LineChart } from "@/global/components/line-chart";
import "./index.less"
import { qDataBase } from "@/global/interface/project-device/quantity";
import { useEffect, useState } from "react";
import { queryInfluxDataList } from "@/api/influx/influx";
import { TimeValue } from "@/global/interface/time-value";
import TnMessage from "@/global/components/message";
import { SensorParameter } from "@/global/interface/device/sensor";
import { Transfer2DisplayScale } from "@/global/utils/unit-type";
import { getDateName } from "@/global/utils/date-utils";


interface IProps {
    waterData: number[][]
    param: SensorParameter
    setEndTime: (e) => void
}

export default function WaterSecondPanel(props: IProps) {

    // const [waterData, setWaterData] = useState<number[][]>([])
    // const [nowTimeStr, setNowTimeStr] = useState<string>("")

    // useEffect(() => {
    //     generateData()
    // }, [])


    // const generateData = () => {
    //     const now = new Date()
    //     setNowTimeStr(getDateName(now.getTime()))
    //     const startTime = new Date(now.getFullYear(), now.getMonth(), now.getDate())

    //     // TODO
    //     queryInfluxDataList(6, "wlevel", "sensor", startTime.getTime(), now.getTime()).then(res => {
    //         let valueList: TimeValue[] = res.data || []
    //         // 组合成数据
    //         let data = []
    //         for (let i = 0; i < valueList?.length; i++) {
    //             data.push([valueList[i].time, valueList[i].value * 1000])
    //         }
    //         setWaterData(data)
    //     }).catch(() => {
    //         TnMessage.error("获取失败！")
    //     })
    // }

    const getChartAxisXLabel = (value: number) => {
        const date = new Date(Number(value));
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0).getTime();
        if (date.getTime() < today) {
            return `${date.getMonth() + 1}-${date.getDate()} ${hours}:${minutes}`
        }
        return `${hours}:${minutes}`;
    }

    const getDateTitle = () => {
        if (props?.waterData?.length > 0) {
            return getDateName(props.waterData[props.waterData.length - 1][0])
        } else {
            return "无数据"
        }
    }

    return (
        <div className="water-chart-panel">
            <LineChart
                chartTitle="水位监测历史图"
                chartValue={getDateTitle()}
                lineData={props.waterData || []}
                getAxisXLabel={getChartAxisXLabel}
                xLabel="时间"
                yLabel={props.param?.unit || ""}
                toolTipXLabel="时间"
                toolTipYLabel="水位"
                tLine_1={props.param?.t2 * Transfer2DisplayScale(props.param?.unit)}
                tLine_2={props.param?.t3 * Transfer2DisplayScale(props.param?.unit)}
                tLine_3={props.param?.t4 * Transfer2DisplayScale(props.param?.unit)}
                onChangeEndTime={(e) => props.setEndTime(e)}
            />
        </div>
    )
}